import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import ContactUsHeader from './ContactUsHeader';
import { IContactUsHeaderProps } from './ContactUsHeader.props';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IContactUsHeaderProps = elementAttributesToProps(domNode);

  return Promise.resolve(<ContactUsHeader {...props} />);
};

export default rehydrator;
